import React from 'react';
import { Create, SimpleForm, SelectArrayInput, TextInput, email, required } from 'react-admin';

export const UserCreate = (props) => (
    <Create { ...props }>
        <SimpleForm>
            <TextInput source="name" label="Name" />
            <TextInput source="position" label="Position" />
            <TextInput source="email" label="Email" validate={ [required(), email()] } />
            <TextInput source="phone_number" label="Phone" />
            <TextInput source="plainPassword" type="password" label="Password" validate={ required() } />

            <SelectArrayInput source="roles" validate={ [required()]} label="Roles" choices={[
                { id: 'ROLE_ADMIN', name: 'Admin' },
                { id: 'ROLE_JOBOFFER', name: 'Job Offer Manager' },
                { id: 'ROLE_RTV', name: 'RTV Manager' },
                { id: 'ROLE_OOH', name: 'OOH Abri Manager' },
                { id: 'ROLE_CONSENT', name: 'Cookie Consent Manager' },
            ]} />

        </SimpleForm>
    </Create>
);